export const ExecutionModeEnum = Object.freeze({
  MANUAL: 'Manual',
  NLP: 'NLP',
  EXTERNAL: 'External',
});
export const DEFAULT_EXECUTION_MODE = ExecutionModeEnum.MANUAL; 